<aside class="sidebar">
  <img src="assets/svg/logos/saude_conectada_logo_min.svg" alt="Logo" />
  <div class="spacer"></div>

  <!-- Home -->
  <a
    class="menu-item"
    routerLink="/home"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <img class="icon" src="../../../assets/svg/icons/home_ic.svg" alt="Home" />
    Home
  </a>

  <!-- Notificações -->
  <a
    class="menu-item notification-menu-item"
    routerLink="/notificacoes"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <img
      class="icon"
      [class.notification-badge-icon]="unreadNotificationsCount > 0 || unreadAvisosCount > 0"
      [src]="unreadNotificationsCount > 0 || unreadAvisosCount > 0 ? '../../../assets/svg/icons/notificacao_badge_ic.svg' : '../../../assets/svg/icons/notificacoes_ic.svg'"
      alt="Notificações"
    />
    Notificações
  </a>

  <!-- Seções do menu (Linha de cuidado / Gerenciamento) -->
  <ng-container *ngFor="let section of menu">
    <div class="nav-section">
      <div class="nav-title">{{ section.title }}</div>

      <ng-container *ngFor="let item of section.items">

        <!-- Item com submenu -->
        <ng-container *ngIf="item.children?.length; else singleLink">
          <ng-container *ngIf="podeVer(item.roles)">
            <div
              class="menu-item"
              (click)="toggle(item.label)"
              [ngClass]="{ active: isAnyChildActive(item.children) }"
              role="button"
              tabindex="0"
              [attr.aria-expanded]="isExpanded(item.label)"
            >
              <img class="icon" [src]="item.icon" alt="" />
              {{ item.label }}
              <img
                src="assets/svg/icons/arrow_right_min_ic.svg"
                alt=""
                class="arrow"
                [class.rotated]="isExpanded(item.label)"
              />
            </div>
            <div *ngIf="isExpanded(item.label)" class="submenu">
              <ng-container *ngFor="let child of item.children">
                <a
                  *ngIf="podeVer(child.roles)"
                  [routerLink]="child.route"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <img class="sub-icon" [src]="child.icon" alt="" />
                  {{ child.label }}
                </a>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>

        <!-- Item sem submenu -->
        <ng-template #singleLink>
          <a
            *ngIf="podeVer(item.roles)"
            class="menu-item"
            [routerLink]="item.route"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <img class="icon" [src]="item.icon" alt="" />
            {{ item.label }}
          </a>
        </ng-template>

      </ng-container>
    </div>
  </ng-container>
</aside>
